// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"71":"ed890282","173":"4936cb2f","366":"3b431e33","453":"ed3810f9","985":"b9e11027"}[chunkId] + ".chunk.js";
};